var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourMeterKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1676,
    cy: 9.68945,
    r: 9,
    fill: "#64DD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1544 10.4501L9.16689 11.4376H8.29295V12.3116H7.41901V13.1855L6.54507 14.0595H4.7972V12.3116L8.40656 8.70221C8.2369 8.14288 8.259 7.54289 8.46936 6.99756C8.67972 6.45223 9.06628 5.99283 9.56762 5.69234C10.069 5.39185 10.6563 5.26751 11.2364 5.33906C11.8165 5.41061 12.3561 5.67395 12.7694 6.08725C13.1827 6.50055 13.446 7.04011 13.5176 7.62021C13.5891 8.20031 13.4648 8.78769 13.1643 9.28903C12.8638 9.79037 12.4044 10.1769 11.8591 10.3873C11.3138 10.5976 10.7138 10.6198 10.1544 10.4501ZM12.2781 8.43129C12.4612 8.24796 12.5859 8.01448 12.6364 7.76034C12.6869 7.5062 12.6609 7.2428 12.5618 7.0034C12.4626 6.76401 12.2948 6.55936 12.0794 6.4153C11.8641 6.27124 11.6108 6.19423 11.3517 6.194C11.0042 6.19431 10.671 6.33262 10.4254 6.57854L12.2781 8.43129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourMeterKey);
export default __webpack_public_path__ + "static/media/hour-meter-key.ccdc098d995f8e7b67e1a84d07fcf4e5.svg";
export { ForwardRef as ReactComponent };